import { render, staticRenderFns } from "./AuditHistoryRelations.vue?vue&type=template&id=2ef79b83&"
import script from "./AuditHistoryRelations.vue?vue&type=script&lang=js&"
export * from "./AuditHistoryRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
